import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword as authResetPassword, confirmResetPassword as authConfirmResetPassword } from 'aws-amplify/auth';

import LoadingButton from "components/LoadingButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { showAlert } from "utils/Alert";
import { ReactComponent as Logo } from 'assets/images/svg/logo.svg';
import FacebookIcon from '@mui/icons-material/Facebook';

import styles from "./style.module.scss";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";
import { trackEvent } from "utils/Analytics";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES } from "utils/Constants";
import PasswordInput from "components/DynamicForm/components/PasswordInput";

const PasswordReset = props => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showCodeInput, setShowCodeInput] = useState(false);

  useEffect(() => {
  })

  const setFormValue = (fieldName, e) => {
    formData[fieldName] = e.target.value;
    setFormData(formData);
  }

  const resetPassword = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (showCodeInput) {
      trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Confim Password Reset")
      submitResetPassword(e);
    } else {
      trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Request Password Reset")
      requestReset(e)
    }

  }

  const requestReset = (e) => {
    if (!formData["username"]) {
      showAlert("danger", "Ingrese el email de su cuenta antes de continuar")
    } else {
      setLoading(true);
      const trimUserName = formData["username"].replace(/\s/g, '');
      authResetPassword({ username: trimUserName })
        .then(r => {
          setShowCodeInput(true);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          if (e && e.code === "UserNotConfirmedException") {
            showAlert("danger", "Por favor active su cuenta, con el enlace que se le envio por correo electronico")
            return
          }
          if (e && e.code === "UserNotFoundException") {
            showAlert("danger", "No existe un usuario con el correo electrónico ingresado")
            return
          }
          if (e && e.code === "NotAuthorizedException") {
            let message = "Usuario y/o contraseña incorrecto";
            if (e.message === "Password attempts exceeded") {
              message = "A excedido la cantidad maxima de intentos de inicio de sesion, por favor espere 5 minutos antes de intentar iniciar sesion nuevamente"
            }
            showAlert("danger", message)
            return
          }
          showAlert("danger", "No fue posible enviar el codigo para el reinicio de la contraseña")
        });
    }
  }

  const submitResetPassword = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (formData["password"] !== formData["repassword"]) {
      showAlert("danger", "La confirmacion de contraseña y la contraseña no son iguales");
      return;
    }
    if (!formData["username"] || !formData["password"]) {
      showAlert("danger", "Ingrese la contraseña nueva de su cuenta antes de continuar")
    } else {
      setLoading(true);
      const trimUserName = formData["username"].replace(/\s/g, '');
      authConfirmResetPassword({
        username: trimUserName,
        newPassword: formData["password"],
        confirmationCode: formData["code"]
      })
        .then(r => {
          setShowConfirm(true);
        })
        .catch(e => {
          setLoading(false);
          if (e && e.code === "UserNotConfirmedException") {
            showAlert("danger", "Por favor active su cuenta, con el enlace que se le envio por correo electronico")
            return
          }
          if (e && e.code === "UserNotFoundException") {
            showAlert("danger", "No existe un usuario con el correo electrónico ingresado")
            return
          }
          if (e && e.code === "NotAuthorizedException") {
            let message = "Usuario y/o contraseña incorrecto";
            if (e.message === "Password attempts exceeded") {
              message = "A excedido la cantidad maxima de intentos de inicio de sesion, por favor espere 5 minutos antes de intentar iniciar sesion nuevamente"
            }
            showAlert("danger", message)
            return
          }
          showAlert("danger", "No fue posible reiniciar la contraseña")
        });
    }
  }

  return (
    <>
      <div className={styles.loginContent}>
        <Container>
          <Row>
            <Col lg={{
              offset: 1,
              size: '4'
            }} md={{
              offset: 1,
              size: '7'
            }}>
              <Form action="#" onSubmit={(e) => resetPassword(e)} className="form" method="">
                <Card className={styles.cardLogin}>
                  <CardHeader className={styles.header}>
                    <Logo className={styles.logo} />
                  </CardHeader>
                  <CardBody>
                    <h5>Reiniciar contraseña</h5>
                    <hr />
                    {showConfirm && (
                      <>
                        <p>
                          Te confirmamos que tu contraseña en Unboxing ha sido restablecida con éxito. A partir de ahora, podrás acceder a tu cuenta utilizando tu nueva contraseña.
                        </p>
                      </>
                    )}
                    {!showConfirm && (
                      <>
                        <p>
                          Si olvidaste tu contraseña, no te preocupes. Ingresa tu correo electrónico y te enviaremos un código para restablecerla. Una vez que recibas el código, podrás crear una nueva contraseña y seguir disfrutando de nuestros servicios sin problemas.
                        </p>
                        <hr />
                        {
                          !showCodeInput && (
                            <FormGroup>
                              <InputGroup>
                                <InputGroupText>
                                  <FontAwesomeIcon icon="fa-solid fa-envelope" />
                                </InputGroupText>
                                <Input
                                  placeholder="Email"
                                  type="text"
                                  name="username"
                                  onChange={(e) => setFormValue("username", e)} />
                              </InputGroup>
                            </FormGroup>)
                        }
                        {
                          showCodeInput && (
                            <>
                              <FormGroup>
                                <InputGroup>
                                  <InputGroupText>
                                    <FontAwesomeIcon icon="fa-solid fa-envelope" />
                                  </InputGroupText>
                                  <Input
                                    placeholder="Codigo enviado por correo"
                                    type="text"
                                    name="code"
                                    onChange={(e) => setFormValue("code", e)} />
                                </InputGroup>
                              </FormGroup>
                              <FormGroup>
                                <PasswordInput
                                  placeholder="Contraseña"
                                  name="password"
                                  onChange={(e) => setFormValue("password", e)}
                                />
                              </FormGroup>
                              <FormGroup>
                                <PasswordInput
                                  placeholder="Confirme Contrasena"
                                  name="repassword"
                                  onChange={(e) => setFormValue("repassword", e)} />
                              </FormGroup>
                            </>
                          )
                        }
                      </>
                    )}
                  </CardBody>
                  <CardFooter>
                    {!showConfirm && (
                      <LoadingButton
                        block
                        className="btn-round mb-3"
                        color="primary"
                        type="submit"
                        loading={loading}
                      >
                        {showConfirm ? "Reiniciar Contraseña" : "Cambiar Contraseña"}
                      </LoadingButton>
                    )}
                    {showConfirm && (
                      <Button
                        block
                        color="success"
                        onClick={() => navigate('/')}
                        className="btn btn-default btn-round"
                      >
                        Iniciar Sesion
                      </Button>
                    )}
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default PasswordReset;